// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"e1c90871e21928f29e10","110":"f63a1036bc16eb20b490","556":"f2fc2e5581141377c75b","777":"28db5a8f9eb7c8320904"}[chunkId] + ".js";
};